webpackJsonp([217754322953031],{

/***/ 283:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	__webpack_require__(283);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['services', 'vendor', 'brokering', 'consulting'];
	var vendorServices = [{
	  title: 'Leasing Products',
	  bullets: ['Fair market value', 'Operating leases', 'Finance leases', 'Software leases', 'Creative structuring', 'Captive program outsourcing']
	}, {
	  title: 'Leasing Profile',
	  bullets: ['Transaction sizes from $20,000 to $2,000,000', 'Customers - three or more years in business, including startups, where the principals have had prior managerial experience in similar lines of business', 'Application only programs up to $75,000', 'Private label lease documents upon request']
	}, {
	  title: 'Industries',
	  bullets: ['Production machinery manufacturers and dealers', 'Construction equipment manufacturers and dealers', 'Medical device equipment manufacturers and dealers', 'VARs and resellers programs', 'Hotel equipment manufacturers and dealers', 'Software manufacturers and dealers', 'Computer manufacturers and dealers', 'Telecom companies', 'FF&E vendors and manufacturers']
	}];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'vendor-hero' },
	      _react2.default.createElement('div', { className: 'vendor-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'vendor-title' },
	      'Vendor'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'vendor-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'services', current: 'vendor' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We understand that an effective financing partner can be extremely valuable to your company by allowing you to focus on selling your equipment. By working closely with each vendor partner, we develop and implement a program that eliminates a customer\'s financial barrier to equipment purchase.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Leasing Solutions\' vendor service also contributes to future sales. Since leasing is for a finite amount of time, our vendor service brings your sales force into periodic contact with clients. These additional interactions produce long-term relationships and increased sales.'
	      ),
	      _react2.default.createElement('br', { className: 'lg' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'vendor-services-title' },
	        'Leasing Solutions provides the following vendor services:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'vendor-services-wrap' },
	        vendorServices.map(function (service, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'vendor-services-list-wrap' },
	            _react2.default.createElement(
	              'p',
	              { className: 'vendor-services-list-subtitle' },
	              service.title,
	              ':'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'vendor-services-list' },
	              service.bullets.map(function (bullet, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i, className: 'vendor-services-list-item' },
	                  bullet
	                );
	              })
	            )
	          );
	        })
	      ),
	      _react2.default.createElement('br', { className: 'lg' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We are committed to understanding your needs as well as the needs of your customers. If you have any questions or are interested in using Leasing Solutions vendor service, please ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'contact-us', to: '/contact' },
	          'contact us'
	        ),
	        '.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-vendor-js-2ed6d4159cbc397c83c1.js